/**
 * Conditionally applies appropriate CSP based on environment
 * 
 * In development: no CSP to allow full flexibility for module loading
 * In production: uses a stricter CSP for security
 */
export const setupCSP = () => {
  // Check if we're in development mode
  const isDevelopment = import.meta.env.DEV;
  
  if (isDevelopment) {
    console.log('Development environment detected - CSP disabled');
    // Remove any existing CSP meta tag to ensure full development flexibility
    const existingCsp = document.querySelector('meta[http-equiv="Content-Security-Policy"]');
    if (existingCsp) {
      existingCsp.remove();
    }
    return;
  }
  
  // In production, apply a strict CSP
  const strictCSP = `default-src 'self'; 
    connect-src 'self' https://accounts.spotify.com https://api.spotify.com 
      https://api.music.apple.com https://play.itunes.apple.com https://*.mzstatic.com 
      https://*.supabase.co https://worker.syncdit.com https://api.syncdit.com 
      https://js.stripe.com https://www.googletagmanager.com https://*.google-analytics.com; 
    script-src 'self' 'unsafe-inline' 'unsafe-eval' https://js-cdn.music.apple.com 
      https://*.mzstatic.com https://js.stripe.com https://challenges.cloudflare.com 
      https://www.googletagmanager.com https://*.google-analytics.com; 
    style-src 'self' 'unsafe-inline' https://sandbox-cdn.paddle.com https://js.stripe.com; 
    img-src 'self' https://i.scdn.co https://*.mzstatic.com https://via.placeholder.com 
      https://images.unsplash.com data: https://js.stripe.com https://www.google-analytics.com; 
    font-src 'self' data:; 
    frame-src https://www.retrogames.cc https://challenges.cloudflare.com 
      https://checkout.paddle.com https://js.stripe.com`;
  
  // Find existing CSP meta tag
  let cspMeta = document.querySelector('meta[http-equiv="Content-Security-Policy"]');
  
  if (cspMeta) {
    // Update existing CSP
    cspMeta.setAttribute('content', strictCSP);
  } else {
    // Create and insert new CSP meta tag if none exists
    cspMeta = document.createElement('meta');
    cspMeta.setAttribute('http-equiv', 'Content-Security-Policy');
    cspMeta.setAttribute('content', strictCSP);
    
    // Insert at the beginning of head
    const head = document.querySelector('head');
    if (head && head.firstChild) {
      head.insertBefore(cspMeta, head.firstChild);
    } else if (head) {
      head.appendChild(cspMeta);
    }
  }
  
  console.log('Production environment detected - strict CSP applied');
}; 